{
  "notes": "Notes",
  "notes-empty": "Add notes.",
  "immediate-family": "Immediate Family",
  "immediate-family-empty": "Add immediate family",
  "family-age": ", Age {{age}}",
  "family-age-months": ", Age {{age}} Months",
  "net-worth-progress": "Net Worth Progress",
  "annual-spending": "Annual Spending*",
  "personal-financial-statement": "Personal Financial Statement",
  "total-assets": "Total Assets",
  "total-debts": "Total Debts",
  "remove-app-access": "Remove App Access",
  "invitation-sent": "Invitation sent {{when}}",
  "mark-onboarding-as-completed": "Mark Onboarding as Completed",
  "onboarding-banner-body": "We’ll hold off on calculating progress in reports until you let us know {{- name}} {{isAre}} fully onboarded.",
  "remove-access-modal-ok": "Remove Access",
  "remove-access-modal-title": "Remove Client Access to Elements?",
  "remove-access-modal-body": "By removing client access to Elements they will no longer be able to access the Elements app.",
  "resend-invitation-body": "Verify the email addresses below and resend the invitation to {{- who}} to join you on Elements.",
  "important-people": "Important People",
  "other-relationship": "Other Relationships",
  "create-one-page-plan": "Create One-Page Plan",
  "one-page-plan-banner-text": "Don't forget—creating a One Page Plan for your client is a great way to help them stay focused and make progress.",
  "edit-financial-purpose-meta-title": "Edit the client's financial purpose",
  "edit-financial-purpose-heading": "Edit Financial Purpose",
  "edit-financial-purpose-placeholder": "Add your client’s financial purpose here...",
  "edit-goals-heading": "Edit Goals",
  "edit-goals-meta-title": "Create, edit, and delete financial goals for this client",
  "client-goals-empty": "Add client goals.",
  "client-next-steps-empty": "Add tasks.",
  "edit-next-steps-meta-title": "Create, edit, and delete tasks for this client",
  "edit-next-steps-heading": "Edit Tasks",
  "add-individual": "Add Individual",
  "edit-individual": "Edit Individual",
  "remove-individual-modal-title": "Remove Individual?",
  "remove-individual-modal-body": "Removing this person will delete them from your client’s profile and they will lose their access to the Elements app. Additionally, any assets or debts assigned to them will revert their ownership back to the primary head-of-household. This action cannot be undone.",
  "remove-individual-modal-ok": "Remove Individual",
  "prospect-banner-body_one": "{{- name}} is a prospect. Convert this prospect to a client to move them to your “Onboarding Group”",
  "prospect-banner-body_other": "{{- name}} are prospects. Convert them to a client to move them to your “Onboarding Group”.",
  "include-debt-payments": "*include debt payments",
  "remove-client": "Remove Client",
  "remove-client-modal-title": "Remove Client?",
  "remove-client-modal-body": "Removing a client will delete them from your list of clients and cannot be undone.",
  "remove-client-notification": "You have removed {{- user}} from your client list.",
  "decayed-percentage": "{{- percentage}}% of balances are decayed",

  "client-page-household-income-button-label": "Household Income",
  "client-page-annual-spending-button-label": "Annual Spending",
  "client-page-scorecard-button-no-report": "Report unavailable",
  "client-page-scorecard-full-screen-button": "Full Screen",
  "client-details-tab-overview": "Overview",
  "client-details-tab-engagement": "Engagement",
  "client-details-tab-accounts": "Accounts",
  "client-details-tab-tasks-goals": "Tasks & Goals",
  "client-details-tab-documents-estate": "Documents",
  "client-details-download-progress-report": "Download Progress Report",
  "client-details-download-pfs-report": "Download Personal Financial Statement",
  "client-details-open-one-page-plan": "Open One-Page Plan",
  "client-details-documents-heading": "Documents",
  "client-details-documents-client-uploads-heading": "Client Uploads",
  "client-details-documents-uploaded-heading": "Uploaded Documents",
  "client-details-upload-document": "Upload Document",
  "client-details-documents-search-placeholder": "Search document titles",
  "client-details-documents-search-empty": "No documents match this search.",
  "client-details-documents-empty": "No uploaded documents yet.",
  "client-details-document-delete-success": "“{{- fileName}}” was deleted.",
  "client-details-documents-loading": "Loading documents...",
  "client-details-documents-error": "Documents could not be loaded.",
  "client-details-documents-retry": "Retry",
  "client-details-documents-unavailable": "Documents are not enabled.",
  "client-details-documents-source-client-upload": "Client Upload",
  "client-details-documents-source-general": "General",
  "client-details-documents-more-sources": "+{{count}} more",
  "client-details-documents-source-accounts": "Accounts",
  "client-details-documents-source-business": "Business",
  "client-details-documents-source-real-estate": "Real Estate",
  "client-details-documents-source-notes": "Notes",
  "client-details-documents-source-property": "Property",
  "client-details-documents-source-debts": "Debts",
  "client-engagement-heading": "Engagement",
  "client-engagement-active-count_one": "{{count}} active",
  "client-engagement-active-count_other": "{{count}} active",
  "client-engagement-featured-heading": "Featured journey",
  "client-engagement-active-heading": "Active",
  "client-engagement-available-heading": "Available tactics",
  "client-engagement-status-active": "Active",
  "client-engagement-ready-status": "Ready to activate",
  "client-engagement-journey-active-status": "Journey active",
  "client-engagement-journey-paused-status": "Journey paused",
  "client-engagement-back": "Back to Engagement",
  "client-engagement-journey-setup-heading": "Review exactly what will happen, then approve the full year once.",
  "client-engagement-journey-management-heading": "The year is running automatically. You stay in control of every unsent email.",
  "client-engagement-concept-preview-heading": "Concept preview",
  "client-engagement-concept-preview-description": "This mock uses sample mailbox and schedule details. Activating it does not send or save anything.",
  "client-engagement-progress-week": "Week {{current}} of {{total}}",
  "client-engagement-progress-starting": "Starting",
  "client-engagement-next-touch-week-8": "Next: Week 8",
  "client-engagement-next-touch-today": "Next: Today",
  "client-engagement-type-sequence": "Sequence",
  "client-engagement-type-one-time": "One-time",
  "client-engagement-touch-count_one": "{{count}} touch",
  "client-engagement-touch-count_other": "{{count}} touches",
  "client-engagement-household": "For {{name}}",
  "client-engagement-this-household": "this household",
  "client-engagement-sequence-heading": "Touch plan",
  "client-engagement-start-tactic": "Start tactic",
  "client-engagement-channel-email": "Email",
  "client-engagement-channel-in-app": "In-app",
  "client-engagement-channel-advisor-reminder": "Advisor reminder",
  "client-engagement-timing-today": "Today",
  "client-engagement-timing-day-3": "Day 3",
  "client-engagement-timing-day-7": "Day 7",
  "client-engagement-timing-day-10": "Day 10",
  "client-engagement-timing-day-14": "Day 14",
  "client-engagement-financial-health-name": "52 Weeks of Financial Health",
  "client-engagement-financial-health-summary": "One useful financial-health lesson each week.",
  "client-engagement-financial-health-duration": "1 year",
  "client-engagement-financial-health-delivery": "52 automatic emails",
  "client-engagement-financial-health-approval": "One-time advisor approval",
  "client-engagement-delivery-heading": "Delivery",
  "client-engagement-recipient-label": "Recipient",
  "client-engagement-sender-label": "From",
  "client-engagement-connected-mailbox": "Your connected advisor mailbox",
  "client-engagement-mailbox-connected": "Mailbox connection confirmed",
  "client-engagement-send-mode-label": "Send mode",
  "client-engagement-send-mode-automatic": "Automatic, with draft fallback",
  "client-engagement-schedule-heading": "Schedule",
  "client-engagement-start-date-label": "Starts",
  "client-engagement-start-date-value": "Next Monday",
  "client-engagement-cadence-label": "Cadence",
  "client-engagement-cadence-value": "Every Monday at 9:00 AM",
  "client-engagement-time-zone-label": "Time zone",
  "client-engagement-time-zone-value": "Household time zone",
  "client-engagement-next-email-heading": "Next email",
  "client-engagement-next-email-description": "This is the first message the household will receive.",
  "client-engagement-next-email-management-description": "Scheduled to send automatically from your mailbox.",
  "client-engagement-future-emails-editable": "All unsent emails remain editable",
  "client-engagement-week-1-label": "Week 1 · Financial health baseline",
  "client-engagement-week-1-subject": "A simple way to see your financial health",
  "client-engagement-week-2-label": "Week 2 · Cash flow",
  "client-engagement-week-2-subject": "The small cash-flow habit that creates options",
  "client-engagement-week-1-scheduled": "Next Monday · 9:00 AM",
  "client-engagement-email-rescheduled-value": "Next Tuesday · 10:00 AM",
  "client-engagement-email-from-label": "From",
  "client-engagement-email-to-label": "To",
  "client-engagement-week-1-greeting": "Hi {{name}},",
  "client-engagement-week-1-greeting-generic": "Hello,",
  "client-engagement-week-1-body-1": "Over the next year, I’ll send one short idea each week to help you understand and improve your financial health.",
  "client-engagement-week-2-body-1": "This week, notice what enters and leaves your accounts. A clear cash-flow picture makes every other financial decision easier.",
  "client-engagement-week-1-body-2": "This week, start by looking at your Elements scorecard. It gives us a shared baseline for the conversations ahead—without asking you to become a financial expert.",
  "client-engagement-week-2-body-2": "You do not need a perfect budget. Just notice one recurring inflow and one recurring outflow before next week.",
  "client-engagement-future-email-body": "This week, we’re focusing on {{topic}}. I’ll keep the idea short and practical so you can take one useful step without adding another financial project to your list.",
  "client-engagement-week-1-signature": "Your advisor",
  "client-engagement-email-body-label": "Email body",
  "client-engagement-edit-email": "Edit email",
  "client-engagement-save-email": "Save changes",
  "client-engagement-edit-next-email": "Edit next email",
  "client-engagement-skip-next-email": "Skip",
  "client-engagement-reschedule-next-email": "Reschedule",
  "client-engagement-curriculum-heading": "52-week curriculum",
  "client-engagement-curriculum-description": "A universal V1 curriculum, personalized with household names and your signature.",
  "client-engagement-curriculum-show-all": "View all 52 emails",
  "client-engagement-curriculum-show-less": "Show first 6 emails",
  "client-engagement-curriculum-week": "Week {{week}}",
  "client-engagement-curriculum-lesson": "{{phase}}: {{topic}}",
  "client-engagement-curriculum-phase-understand": "Understand",
  "client-engagement-curriculum-phase-strengthen": "Strengthen",
  "client-engagement-curriculum-phase-apply": "Apply",
  "client-engagement-curriculum-phase-review": "Review",
  "client-engagement-curriculum-topic-scorecard": "Your financial-health scorecard",
  "client-engagement-curriculum-topic-cash-flow": "Cash flow",
  "client-engagement-curriculum-topic-emergency-fund": "Emergency reserves",
  "client-engagement-curriculum-topic-debt": "Debt",
  "client-engagement-curriculum-topic-savings": "Savings",
  "client-engagement-curriculum-topic-retirement": "Retirement readiness",
  "client-engagement-curriculum-topic-investing": "Investing",
  "client-engagement-curriculum-topic-taxes": "Tax awareness",
  "client-engagement-curriculum-topic-insurance": "Risk and insurance",
  "client-engagement-curriculum-topic-estate": "Estate readiness",
  "client-engagement-curriculum-topic-goals": "Goals",
  "client-engagement-curriculum-topic-progress": "Progress",
  "client-engagement-curriculum-topic-review": "Quarterly review",
  "client-engagement-checkpoints-heading": "Advisor checkpoints",
  "client-engagement-checkpoints-description": "Elements creates an advisor task at each quarter so the automation leads to a real planning conversation.",
  "client-engagement-checkpoint-week": "Week {{week}} check-in",
  "client-engagement-fallback-heading": "If an email cannot send",
  "client-engagement-fallback-draft-label": "Elements creates the identical email as a draft in your mailbox, notifies you, and asks you to send it manually.",
  "client-engagement-fallback-step-failed": "Send failed",
  "client-engagement-fallback-step-draft": "Draft created",
  "client-engagement-fallback-step-task": "Advisor notified",
  "client-engagement-readiness-mailbox": "Advisor mailbox connected",
  "client-engagement-readiness-recipient": "Household email available",
  "client-engagement-readiness-schedule": "Schedule and signature ready",
  "client-engagement-activate-journey": "Activate 52-week journey",
  "client-engagement-timeline-heading": "Journey timeline",
  "client-engagement-timeline-activated": "Journey activated",
  "client-engagement-timeline-today": "Today · One-time approval recorded",
  "client-engagement-timeline-week-1": "Week 1 email scheduled",
  "client-engagement-timeline-checkpoint": "First advisor checkpoint",
  "client-engagement-timeline-week-13": "Week 13 · Advisor task will be created",
  "client-engagement-watch-heading": "Elements is watching for",
  "client-engagement-watch-mailbox": "Disconnected or expired mailbox connection",
  "client-engagement-watch-recipient": "Missing or changed household email",
  "client-engagement-watch-delivery": "A failed email delivery",
  "client-engagement-watch-activity": "Meaningful household activity between checkpoints",
  "client-engagement-pause-journey": "Pause journey",
  "client-engagement-resume-journey": "Resume journey",
  "client-engagement-end-journey": "End journey",
  "client-engagement-quarterly-check-in-name": "Quarterly Financial Check-in",
  "client-engagement-quarterly-check-in-summary": "Gather updates, review progress, and prepare the next conversation.",
  "client-engagement-quarterly-check-in-duration": "14 days",
  "client-engagement-quarterly-check-in-touch-1": "Share the quarterly check-in",
  "client-engagement-quarterly-check-in-touch-2": "Prompt the household to update their numbers",
  "client-engagement-quarterly-check-in-touch-3": "Review the scorecard and follow up",
  "client-engagement-data-refresh-name": "Refresh Household Data",
  "client-engagement-data-refresh-summary": "Ask the household to reconnect accounts and confirm key inputs.",
  "client-engagement-data-refresh-duration": "7 days",
  "client-engagement-data-refresh-touch-1": "Request updated household data",
  "client-engagement-data-refresh-touch-2": "Review anything still missing",
  "client-engagement-celebrate-name": "Celebrate Progress",
  "client-engagement-celebrate-summary": "Send a personal note recognizing a meaningful improvement.",
  "client-engagement-celebrate-duration": "Today",
  "client-engagement-celebrate-touch-1": "Send the progress note",
  "client-engagement-annual-review-name": "Annual Review Preparation",
  "client-engagement-annual-review-summary": "Collect updates before the annual planning conversation.",
  "client-engagement-annual-review-duration": "21 days",
  "client-engagement-annual-review-touch-1": "Share the annual review checklist",
  "client-engagement-annual-review-touch-2": "Prompt the household to finish updates",
  "client-engagement-annual-review-touch-3": "Review changes before the meeting",
  "income-page-heading": "Income & Spending",
  "income-page-description": "Manage household income sources and spending estimates here.",
  "income-page-empty-description": "Add your household income sources to estimate the amount you expect to earn during the current year.",
  "income-page-segmented-control-income": "Income Sources",
  "income-page-segmented-control-spending": "Spending",
  "income-page-add-income-source-button": "Add Income Source",
  "income-page-total-income-row-title": "Total Household Income",

  "spending-page-description": "Make sure to include all debt payments (currently {{- debtPaymentsDisplay}} {{- frequencySuffix}}) in this estimate.  We'll back out the Debt Payments from Burn Rate so they don't get double counted with Debt Rate too.",
  "spending-page-form-spending-amount-input-label": "Estimated Spending",

  "report-preview-page-action-button": "Download Report",
  "report-preview-page-report-name": "{{- givenName}} {{- familyName}}'s {{reportTypeDisplay}} ({{dateDisplay}})",
  "report-preview-error-page-modal-title": "Hmmmm...",
  "report-preview-error-page-modal-body": "Looks like we’re having trouble loading that report right now. Try again later. If this is happening to you frequently, contact us to help get to the bottom of this error.",
  "report-preview-error-page-modal-primary-action": "Contact Us",

  "download-element-report": "Download {{element}} Report",
  "download-report": "Download Report",
  "add-to-client-group": "Add to Group...",
  "remove-all-custom-groups": "Remove from All",
  "client-groups-move-to-group": "{{- name}} moved to \"{{- group}}\"",
  "change-client-notifications": "Communication Preferences",
  "change-client-notifications-description": "Select which team members receive email notifications when this client takes action (e.g., completes onboarding, sends a message).",
  "change-client-notifications-description-opt-out": "Select which team members receive email notifications. Leave all selected to notify everyone.",
  "change-client-notifications-description-opt-in": "Select which team members receive email notifications. Only selected advisors will be notified.",
  "client-notifications-updated": "Communication preferences updated.",
  "client-notifications-update-error": "Failed to update communication preferences. Please try again.",
  "client-notifications-select-all": "Select all",
  "client-groups-removed-from-group": "{{- name}} removed from \"{{- group}}\"",

  "ai-assessment": {
    "invite-link": {
      "toggle-disclaimer": {
        "on": "Clients who onboard with this link will automatically be directed to an AI generated assessment at the end of onboarding.",
        "off": "Clients who onboard with this link will be directed to their Elements Scorecard or their custom assessment, if present, after onboarding."
      }
    },
    "client-options": {
      "toggle-disclaimer": {
        "on": "This client will be able to access and regenerate an AI assessment on their own",
        "off": "This client can only access assessments that have been manually edited and published by their advisor"
      }
    }
  }
}
